
const allEnv = Object.keys(process.env)
  .reduce((env, key) => {
    env[key] = process.env[key];
    return env;
  }, {} as Record<string, string | undefined>)

enum EnvList {
  dev = 'dev',
  development = 'dev',
  staging = 'staging',
  uat = 'uat',
  prod = 'prod',
  production = 'prod',
}
const envList: Record<keyof typeof EnvList, string> = { ...EnvList }
const rawEnv = process.env.REACT_APP_ENV?.toLowerCase() ?? 'dev'

const Node_Env = envList[rawEnv as keyof typeof envList] ?? envList.dev
// Note: Old logic for environment
// const Node_Env = process.env.REACT_APP_ENV?.toLowerCase() === EnvList.dev ? '' : process.env.REACT_APP_ENV?.toLowerCase() === 'prod' ? 'PROD' : process.env.REACT_APP_ENV === 'Uat' ? 'UAT' : process.env.REACT_APP_ENV === 'Staging' ? 'Staging' : 'Development';

const apiList: Record<string, string> = {
    dev: 'http://localhost:8080/api',
    uat: 'https://filemule-internal-api-uat-c7cvhdarhxcqexgr.centralus-01.azurewebsites.net/api',
    staging: 'https://filemule-internal-api-staging-bqgvf9cdh5ard6hw.centralus-01.azurewebsites.net/api',
    prod: 'https://filemule-internal-api-c7cvhdarhxcqexgr.centralus-01.azurewebsites.net/api',
    // live: 'http://filemule-api-live.azurewebsites.net/api',
};

const API_URL = apiList[Node_Env];

// Helper function that handles potential falsey values in environment variables
const getFeatureFlag = (baseEnvVar: string) => {
    const envSpecificVar = `${baseEnvVar}_${Node_Env.toUpperCase()}`;

    // Check both base and environment-specific variables
    const baseValue = (process.env[baseEnvVar]?.toLowerCase() ?? 'false') === 'true';
    const envValue = (process.env[envSpecificVar]?.toLowerCase() ?? 'false') === 'true';

    return baseValue || envValue;
};

export const AppFlags = {
    // stateReports: getFeatureFlag('REACT_APP_FLAG_STATE_REPORTS'),
    // otherReports: getFeatureFlag('REACT_APP_FLAG_OTHER_REPORTS'),
    enableStateReports: getFeatureFlag('REACT_APP_ENABLE_STATE_REPORTS'),
    enableOtherReports: getFeatureFlag('REACT_APP_ENABLE_OTHER_REPORTS'),
    enableNonPremiumEndorsement: getFeatureFlag('REACT_APP_ENABLE_NON_PREMIUM_ENDORSEMENT'),
    enableYearToDateReport: getFeatureFlag('REACT_APP_ENABLE_YEAR_TO_DATE_REPORT'),
};
// Example Flag Usage in development:  'REACT_APP_FLAG_STATE_REPORTS_DEV = true'
//                       Staging:      'REACT_APP_FLAG_STATE_REPORTS_STAGING = true'
//                       UAT:          'REACT_APP_FLAG_STATE_REPORTS_UAT = true'
//                       production:   'REACT_APP_FLAG_STATE_REPORTS_PROD = true'
//                       for all envs: 'REACT_APP_FLAG_STATE_REPORTS = true'

const config = {
  allEnv,     // Note: all variables in .env
  Node_Env,   // Note: Current Environment.
  envList,    // Note: List of environments.
  url: {
    API_URL   // Note: API URL for the current enviroment.
  },
  AppFlags,   // Note: Feature Flag configuration for the current environment.
}

export default config
